import { render } from "./Ideas.vue?vue&type=template&id=315f5ade&scoped=true"
import script from "./Ideas.vue?vue&type=script&lang=js"
export * from "./Ideas.vue?vue&type=script&lang=js"

import "./Ideas.vue?vue&type=style&index=0&id=315f5ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315f5ade"]])

export default __exports__